import { svgUrl as svgUrlBase } from '~/utils'

export const svgUrl = (name: string) => svgUrlBase(`ninesegsAnalyzer/${name}`)
